import { render } from "./SidingPage.vue?vue&type=template&id=48aa9aa4&scoped=true"
import script from "./SidingPage.vue?vue&type=script&lang=js"
export * from "./SidingPage.vue?vue&type=script&lang=js"

import "./SidingPage.vue?vue&type=style&index=0&id=48aa9aa4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48aa9aa4"]])

export default __exports__